import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import PdfIcon from '../Icons/PdfIcon';
import DocxIcon from '../Icons/DocxIcon';
import XlsxIcon from '../Icons/XlsxIcon';

import InsertDriveFile from '@material-ui/icons/InsertDriveFile';

const useStyles = makeStyles((theme) => ({
  documentLink: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'inline-block',
  },
  documentPreview: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.action.hover
        : 'rgba(0, 0, 0, 0.04)',
    border: `1px solid ${
      theme.palette.type === 'dark'
        ? theme.palette.divider
        : '#0000002f'
    }`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 1.5),
    marginBottom: theme.spacing(0.5),
    maxWidth: 250,
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.action.selected
          : 'rgba(0, 0, 0, 0.08)',
    },
  },
  iconContainer: {
    marginRight: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  filename: {
    fontSize: 15,
    fontWeight: 500,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.text.primary
        : '#111b21',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  metadata: {
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
}));


const DocumentMessage = ({ message }) => {
  const classes = useStyles();

  const filename = message.mediaUrl.split('/').pop();

  let icon;
  let fileTypeDescription = "Documento";

  if (/\.(pdf)$/i.test(filename)) {
    icon = <PdfIcon style={{ width: 40, height: 40 }} />;
    fileTypeDescription = "PDF";
  } else if (/\.(docx|doc)$/i.test(filename)) {
    icon = <DocxIcon style={{ width: 40, height: 40 }} />;
    fileTypeDescription = "Documento de Word";
  } else if (/\.(xlsx|xls)$/i.test(filename)) {
    icon = <XlsxIcon style={{ width: 35, height: 35 }} />;
    fileTypeDescription = "Documento de Excel";
  } else {
    icon = <InsertDriveFile style={{ width: 40, height: 40, color: '#757575' }} />;
  }

  return (
    <a
      href={message.mediaUrl}
      download={filename}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.documentLink}
    >
      <div className={classes.documentPreview}>
        <div className={classes.iconContainer}>{icon}</div>
        <div className={classes.textContainer}>
          <span className={classes.filename}>{filename}</span>
          <span className={classes.metadata}>{fileTypeDescription}</span>
        </div>
      </div>
    </a>
  );
};

export default DocumentMessage;